// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `     /* 2025.10.16 esg css 추가 */
     .esg {
         max-width: 1000px;
         margin: 0 auto;
         padding: 80px 20px;
     }

     .esg-header {
         color: #f57c00;
         font-size: 20px;
         font-weight: 700;
         margin-bottom: 8px;
     }

     .esg-title {
         font-size: 36px;
         font-weight: 700;
         margin-bottom: 16px;
     }

     .esg-subtitle {
         font-size: 22px;
         font-weight: 700;
         margin-top: 10px;
         margin-bottom: 40px;
     }

     .esg-section>p {
         margin-bottom: 20px;
     }

     .esg-section {
         margin-top: 20px;
         margin-bottom: 60px;
     }

     .esg-section h4 {
         font-size: 18px;
         font-weight: 600;
         margin-bottom: 8px;
     }

     .esg>span {
         font-size: 16px;
         color: #727272;
     }


     .esg-img {
         display: grid;
         grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
         gap: 20px;
         justify-content: center;
         align-items: center;
     }

     .esg-img img {
         max-width: 100%;
         height: auto;
         display: block;
         margin: 0 auto;

     }

     /* 2025.10.31 */
     .esg-text {
         margin-top: 0;
         display: flex;
         gap: 20px;
         align-items: center;
         margin: 40px 0;
         flex: 1;
     }

     .esg-img-list {
         display: flex;
         gap: 10px;
         /* 이미지 사이 간격 */
     }

     .caption {
         text-align: center;
         font-size: 14px;
         color: #2e7d32;
         margin-top: 5px;
     }

     @media screen and (max-width: 768px) {
         .esg-text {
             flex-direction: column;
         }

         .esg-img-list {
             justify-content: flex-start;
         }

         /* .esg-img img {
             height: 200px;
         } */

         /* 2025.10.21 이미지 css 수정 */
         .esg-img img {
             width: 100%;
             height: auto;
             object-fit: contain;
         }

         .esg-text {
             margin-top: 0;
             display: flex;
             gap: 20px;
             align-items: center;
             margin: 40px 0;
             flex: 1;
         }

         .esg-text h3 {
             font-size: 20px;
             margin-bottom: 12px;
         }

         .esg-text p {
             line-height: 1.6;
         }

         .esg-img-list {
             display: flex;
             gap: 12px;
             flex: 1;
             justify-content: flex-end;
         }

         .esg-img {
             flex: 1;
         }

         /* .esg-img img {
             object-fit: cover;
         } */

     }


     @media screen and (max-width: 768px) {
         .esg-text {
             flex-direction: column;
         }

         .esg-img-list {
             justify-content: flex-start;
         }

         .esg-img img {
             height: 200px;
         }

         .esg-img img {
             width: 100%;

         }
     }

`, "",{"version":3,"sources":["webpack://./static/css/esg.css"],"names":[],"mappings":"KAAK,0BAA0B;KAC1B;SACI,iBAAiB;SACjB,cAAc;SACd,kBAAkB;KACtB;;KAEA;SACI,cAAc;SACd,eAAe;SACf,gBAAgB;SAChB,kBAAkB;KACtB;;KAEA;SACI,eAAe;SACf,gBAAgB;SAChB,mBAAmB;KACvB;;KAEA;SACI,eAAe;SACf,gBAAgB;SAChB,gBAAgB;SAChB,mBAAmB;KACvB;;KAEA;SACI,mBAAmB;KACvB;;KAEA;SACI,gBAAgB;SAChB,mBAAmB;KACvB;;KAEA;SACI,eAAe;SACf,gBAAgB;SAChB,kBAAkB;KACtB;;KAEA;SACI,eAAe;SACf,cAAc;KAClB;;;KAGA;SACI,aAAa;SACb,2DAA2D;SAC3D,SAAS;SACT,uBAAuB;SACvB,mBAAmB;KACvB;;KAEA;SACI,eAAe;SACf,YAAY;SACZ,cAAc;SACd,cAAc;;KAElB;;KAEA,eAAe;KACf;SACI,aAAa;SACb,aAAa;SACb,SAAS;SACT,mBAAmB;SACnB,cAAc;SACd,OAAO;KACX;;KAEA;SACI,aAAa;SACb,SAAS;SACT,cAAc;KAClB;;KAEA;SACI,kBAAkB;SAClB,eAAe;SACf,cAAc;SACd,eAAe;KACnB;;KAEA;SACI;aACI,sBAAsB;SAC1B;;SAEA;aACI,2BAA2B;SAC/B;;SAEA;;YAEG;;SAEH,0BAA0B;SAC1B;aACI,WAAW;aACX,YAAY;aACZ,mBAAmB;SACvB;;SAEA;aACI,aAAa;aACb,aAAa;aACb,SAAS;aACT,mBAAmB;aACnB,cAAc;aACd,OAAO;SACX;;SAEA;aACI,eAAe;aACf,mBAAmB;SACvB;;SAEA;aACI,gBAAgB;SACpB;;SAEA;aACI,aAAa;aACb,SAAS;aACT,OAAO;aACP,yBAAyB;SAC7B;;SAEA;aACI,OAAO;SACX;;SAEA;;YAEG;;KAEP;;;KAGA;SACI;aACI,sBAAsB;SAC1B;;SAEA;aACI,2BAA2B;SAC/B;;SAEA;aACI,aAAa;SACjB;;SAEA;aACI,WAAW;;SAEf;KACJ","sourcesContent":["     /* 2025.10.16 esg css 추가 */\n     .esg {\n         max-width: 1000px;\n         margin: 0 auto;\n         padding: 80px 20px;\n     }\n\n     .esg-header {\n         color: #f57c00;\n         font-size: 20px;\n         font-weight: 700;\n         margin-bottom: 8px;\n     }\n\n     .esg-title {\n         font-size: 36px;\n         font-weight: 700;\n         margin-bottom: 16px;\n     }\n\n     .esg-subtitle {\n         font-size: 22px;\n         font-weight: 700;\n         margin-top: 10px;\n         margin-bottom: 40px;\n     }\n\n     .esg-section>p {\n         margin-bottom: 20px;\n     }\n\n     .esg-section {\n         margin-top: 20px;\n         margin-bottom: 60px;\n     }\n\n     .esg-section h4 {\n         font-size: 18px;\n         font-weight: 600;\n         margin-bottom: 8px;\n     }\n\n     .esg>span {\n         font-size: 16px;\n         color: #727272;\n     }\n\n\n     .esg-img {\n         display: grid;\n         grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n         gap: 20px;\n         justify-content: center;\n         align-items: center;\n     }\n\n     .esg-img img {\n         max-width: 100%;\n         height: auto;\n         display: block;\n         margin: 0 auto;\n\n     }\n\n     /* 2025.10.31 */\n     .esg-text {\n         margin-top: 0;\n         display: flex;\n         gap: 20px;\n         align-items: center;\n         margin: 40px 0;\n         flex: 1;\n     }\n\n     .esg-img-list {\n         display: flex;\n         gap: 10px;\n         /* 이미지 사이 간격 */\n     }\n\n     .caption {\n         text-align: center;\n         font-size: 14px;\n         color: #2e7d32;\n         margin-top: 5px;\n     }\n\n     @media screen and (max-width: 768px) {\n         .esg-text {\n             flex-direction: column;\n         }\n\n         .esg-img-list {\n             justify-content: flex-start;\n         }\n\n         /* .esg-img img {\n             height: 200px;\n         } */\n\n         /* 2025.10.21 이미지 css 수정 */\n         .esg-img img {\n             width: 100%;\n             height: auto;\n             object-fit: contain;\n         }\n\n         .esg-text {\n             margin-top: 0;\n             display: flex;\n             gap: 20px;\n             align-items: center;\n             margin: 40px 0;\n             flex: 1;\n         }\n\n         .esg-text h3 {\n             font-size: 20px;\n             margin-bottom: 12px;\n         }\n\n         .esg-text p {\n             line-height: 1.6;\n         }\n\n         .esg-img-list {\n             display: flex;\n             gap: 12px;\n             flex: 1;\n             justify-content: flex-end;\n         }\n\n         .esg-img {\n             flex: 1;\n         }\n\n         /* .esg-img img {\n             object-fit: cover;\n         } */\n\n     }\n\n\n     @media screen and (max-width: 768px) {\n         .esg-text {\n             flex-direction: column;\n         }\n\n         .esg-img-list {\n             justify-content: flex-start;\n         }\n\n         .esg-img img {\n             height: 200px;\n         }\n\n         .esg-img img {\n             width: 100%;\n\n         }\n     }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
